module.exports = __webpack_public_path__ + "img/广告1.be38741a.png";